/**
 * Ícones do desfecho.
 *
 * Os demais ícones do app vêm direto do `lucide-react-native`. Estes ficam aqui
 * porque são contrato com o operador junto com a cor e a palavra
 * (`DESFECHO`, em `src/dominio/tipos.ts`): trocar o desenho por outro parecido
 * muda o que a portaria reconhece de longe.
 */

import React from 'react';
import {Circle, Path, Rect, Svg} from 'react-native-svg';

import type {IconeDesfecho} from '../dominio/tipos';

/** Traçados na grade 24×24 do Lucide, na ordem em que são desenhados. */
const TRACOS: Record<IconeDesfecho, string[]> = {
  entrou: ['M20 6 9 17l-5-5'],
  relogio: ['@circle', 'M12 6v6l4 2'],
  proibido: ['@circle', 'm4.9 4.9 14.2 14.2'],
  alertaTriangulo: [
    'm21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z',
    'M12 9v4',
    'M12 17h.01',
  ],
  alertaCirculo: ['@circle', 'M12 8v4', 'M12 16h.01'],
  ingresso: [
    'M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z',
    'M13 5v2',
    'M13 11v2',
    'M13 17v2',
  ],
  lote: ['@retangulo', 'M3 9h18'],
  setor: ['M3 21h18', 'M5 21V7l7-4 7 4v14', 'M9 21v-6h6v6'],
  setorFora: ['M3 21h18', 'M5 21V7l7-4 7 4v14', 'm4.9 4.9 14.2 14.2'],
  outroEvento: ['M8 2v4', 'M16 2v4', '@calendario', 'm9 14 6 0'],
  // Calendário com X. Divide a forma com o `outroEvento`, que é calendário
  // com traço — os dois falam de data errada. O X e a linha do cabeçalho são
  // o que separa um do outro de longe.
  calendarioFora: [
    'M8 2v4',
    'M16 2v4',
    '@calendario',
    'M3 10h18',
    'm14 14-4 4',
    'm10 14 4 4',
  ],
};

export function IconeDoDesfecho({
  nome,
  tamanho = 24,
  cor,
  espessura = 2.4,
}: {
  nome: IconeDesfecho;
  tamanho?: number;
  cor: string;
  espessura?: number;
}) {
  return (
    <Svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 24 24"
      fill="none"
      stroke={cor}
      strokeWidth={espessura}
      strokeLinecap="round"
      strokeLinejoin="round">
      {TRACOS[nome].map((traco, indice) => {
        if (traco === '@circle') {
          return <Circle key={indice} cx={12} cy={12} r={10} />;
        }
        if (traco === '@retangulo') {
          return <Rect key={indice} x={3} y={3} width={18} height={18} rx={2} />;
        }
        if (traco === '@calendario') {
          return <Rect key={indice} x={3} y={4} width={18} height={18} rx={2} />;
        }
        return <Path key={indice} d={traco} />;
      })}
    </Svg>
  );
}
